import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { AxiosError } from 'axios'

import { ACCREDITED_ESTABLISHMENTS_SUB_SPECIALTIES_FILTER } from '@/global/constants/reactQueryKeys'
import {
  GetFilterResponse,
  getSubSpecialtiesFilterOptions
} from '@/modules/accredited-establishments/api'
import { addError } from '@/global/plugins/observability'
import {
  AccreditedEstablishmentsCode,
  Context
} from '@/global/plugins/observability/observability.constants'
import { ApiErrorResponse } from '@/global/api/types'
import { toastApiError } from '@/global/utils/toastApiError/toastApiError'

export const useGetSubSpecialtiesFilter = (specialtyId?: string) => {
  const result = useQuery<GetFilterResponse, AxiosError<ApiErrorResponse>>({
    queryKey: [
      ...ACCREDITED_ESTABLISHMENTS_SUB_SPECIALTIES_FILTER,
      specialtyId
    ],
    queryFn: () => getSubSpecialtiesFilterOptions(specialtyId as string),
    enabled: !!specialtyId && specialtyId !== 'ALL'
  })

  const { error } = result

  useEffect(() => {
    if (error) {
      const data = {
        context: Context.ACCREDITED_ESTABLISHMENTS,
        code: AccreditedEstablishmentsCode.GET_SUB_SPECIALTIES_FILTER_OPTIONS_ERROR,
        message: 'Erro ao obter as subespecialidades'
      }
      addError({ error, data })

      toastApiError({ status: error.response?.status })
    }
  }, [error])

  return result
}
